import { Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { MyApprovalsPage } from '@/pages/MyApprovalsPage';
import { LoginPage } from '@/pages/LoginPage';
import { NewTripPage } from '@/pages/trips/NewTripPage';
import { TripDetailPage } from '@/pages/trips/TripDetailPage';
import { EditTripPage } from '@/pages/trips/EditTripPage';
import { CityRedirectPage } from '@/pages/trips/CityRedirectPage';
import { CityPage } from '@/pages/trips/CityPage';
import { ProtectedRoute } from './ProtectedRoute';

export function AppRouter() {
  const withProtection = (component: JSX.Element) => <ProtectedRoute>{component}</ProtectedRoute>;

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={withProtection(<HomePage />)} />
      <Route path="/trips/new" element={withProtection(<NewTripPage />)} />
      <Route path="/trips/:id" element={withProtection(<TripDetailPage />)} />
      <Route path="/trips/:id/edit" element={withProtection(<EditTripPage />)} />
      <Route path="/trips/:id/cities" element={withProtection(<CityRedirectPage />)} />
      <Route path="/trips/:id/cities/:cityId" element={withProtection(<CityPage />)} />
      <Route path="/approvals" element={withProtection(<MyApprovalsPage />)} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
